import request from "@/utils/request";

export function getFloorList(params) {
  return request({
    url: "/Room/GetFloorGroup",
    method: "get",
    params
  });
}
export function editFloor(data) {
  return request({
    url: "/Room/EditFloor",
    method: "post",
    data
  });
}
export function addFloor(data) {
  return request({
    url: "/Room/AddFloor",
    method: "post",
    data
  });
}
export function deleteFloor(data) {
  return request({
    url: "/Room/DeleteFloor",
    method: "delete",
    data
  });
}
export function getRoomList(params) {
  return request({
    url: "/Room/GetRoomGroupWithPaging",
    method: "get",
    params
  });
}
export function addRoom(data) {
  return request({
    url: "/Room/AddRoom",
    method: "post",
    data
  });
}
export function editRoom(data) {
  return request({
    url: "/Room/EditRoom",
    method: "post",
    data
  });
}
export function deleteRoom(data) {
  return request({
    url: "/Room/deleteRoom",
    method: "delete",
    data
  });
}
export function disableRoom(data) {
  return request({
    url: "/Room/disableRoom",
    method: "post",
    data
  });
}
export function enableRoom(data) {
  return request({
    url: "/Room/EnableRoom",
    method: "post",
    data
  });
}
export function getRoomSelect(params) {
  return request({
    url: "/Room/GetRoomGroup",
    method: "get",
    params
  });
}
export function getStudentFloorList(params) {
  return request({
    url: "/Room/GetStudentFloorGroup",
    method: "get",
    params
  });
}
export function getGuestFloorList(params) {
  return request({
    url: "/Room/GetGuestFloorGroup",
    method: "get",
    params
  });
}
export function updateStatus(params) {
  return request({
    url: "/Room/UpdateStatus",
    method: "post",
    params
  });
}
